import { createSlice } from '@reduxjs/toolkit';
import { type RootState } from '@/store';

interface NetworkStatusState {
  isOnline: boolean;
}

const initialState: NetworkStatusState = {
  isOnline: typeof navigator !== 'undefined' ? navigator.onLine : true,
};

const networkStatusSlice = createSlice({
  name: 'networkStatus',
  initialState,
  reducers: {
    setOnline: (state) => {
      state.isOnline = true;
    },
    setOffline: (state) => {
      state.isOnline = false;
    },
  },
});

export const { setOnline, setOffline } = networkStatusSlice.actions;
export const selectIsOnline = (state: RootState): boolean => state.networkStatus.isOnline;
export const networkStatusReducer = networkStatusSlice.reducer;
